"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
interface Props {
  text?: string;
  children?: ReactNode;
  className?: string;
  moreLabel?: string;
  lessLabel?: string;
}
export default function ExpandableText(t0) {
  const $ = _c(21);
  const {
    text,
    children,
    className,
    moreLabel: t1,
    lessLabel: t2
  } = t0;
  const moreLabel = t1 === undefined ? "more" : t1;
  const lessLabel = t2 === undefined ? "less" : t2;
  const contentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  let t3;
  let t4;
  if ($[0] !== isExpanded) {
    t3 = () => {
      if (isExpanded) {
        return;
      }
      const element = contentRef.current;
      if (!element) {
        return;
      }
      const measureOverflow = () => setIsOverflowing(element.scrollHeight > element.clientHeight + 1);
      measureOverflow();
      const observer = new ResizeObserver(measureOverflow);
      observer.observe(element);
      return () => observer.disconnect();
    };
    t4 = [isExpanded];
    $[0] = isExpanded;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  const content = children ?? text;
  if (content === undefined || content === null) {
    return null;
  }
  const t5 = !isExpanded && "line-clamp-3";
  let t6;
  if ($[3] !== className || $[4] !== t5) {
    t6 = cn(className, t5);
    $[3] = className;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isExpanded || $[7] !== isOverflowing || $[8] !== lessLabel) {
    t7 = isOverflowing && isExpanded && <>{" "}<Button type="button" variant="link" size="inline" onClick={() => setIsExpanded(false)} className="text-sm font-semibold hover:!opacity-100">{lessLabel}</Button></>;
    $[6] = isExpanded;
    $[7] = isOverflowing;
    $[8] = lessLabel;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== content || $[11] !== t6 || $[12] !== t7) {
    t8 = <p ref={contentRef} className={t6}>{content}{t7}</p>;
    $[10] = content;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isExpanded || $[15] !== isOverflowing || $[16] !== moreLabel) {
    t9 = isOverflowing && !isExpanded && <Button type="button" variant="link" size="inline" onClick={() => setIsExpanded(true)} className={cn("absolute bottom-0 right-0 pl-10 text-sm font-semibold hover:!opacity-100", "bg-[linear-gradient(to_right,rgba(255,255,255,0)_0,rgba(255,255,255,1)_32px,rgba(255,255,255,1)_100%)]")}>{moreLabel}</Button>;
    $[14] = isExpanded;
    $[15] = isOverflowing;
    $[16] = moreLabel;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="relative">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}